const primaryNavConstants = {
  PRIMARY_NAV_HEIGHT: 80,
};

export default primaryNavConstants;
